import React, { ReactElement } from 'react'
import CX from 'classnames'
import { Classes, Icon, IconName } from '@blueprintjs/core'

export interface InputLabelProps {
  title?: string | ReactElement
  style?: React.CSSProperties
  className?: string
  optional?: boolean
  required?: boolean
  requiredLabelStyle?: React.CSSProperties
  requiredLabelIconName?: IconName
}

export const InputLabel: React.FC<InputLabelProps> = props => {
  const requiredLabelStyle = props.requiredLabelStyle || {}
  const { requiredLabelIconName } = props

  return (
    <label className={CX(Classes.LABEL, props.className)} style={props.style}>
      {props.required && requiredLabelIconName && (
        <Icon color="#5c7080" icon={requiredLabelIconName} style={{ marginLeft: 4 }} />
      )}
      {props.title}
      {props.optional && <span className={Classes.TEXT_MUTED}> optional</span>}
      {props.required && !requiredLabelIconName && (
        <span className={Classes.TEXT_MUTED} style={requiredLabelStyle} data-testid="required-text-label">
          {' '}
          Required
        </span>
      )}
      {props.children}
    </label>
  )
}
